import { hotjar } from 'react-hotjar';

/**
 * Function that identifies the heap user.
 * see https://developers.heap.io/reference#identify
 * @param {string} email Users email that be displayed on the User session card on Heap
 */
export const identify = (email) => {
  // window.heap.identify(email)
};

/**
 * Util function that calls heap track with the event name and properties
 * see https://developers.heap.io/reference#api-reference-overview
 * @param {string} event_name string responsible for how the event is sent to heap, this will be used for filtering purposes on heap
 * @param {object} properties Dictionary responible for any additional data to be sent to heap.
 */
export const track = (event_name, properties = {}) => {
  // NOTE @{lbarrick}: Not entirely sure why we're adding the host in the call, but
  // const finalProps = { host: window.location.host, ...properties };
  // window.heap.track(event_name, finalProps)
};

/**
 * Util function that adds a key onto the user object in heap
 * see https://developers.heap.io/reference#adduserproperties
 * @param {object} properties Dictionary that adds keys onto the user object in heap. Values must be a string or integer.
 */
export const addUserProperty = (properties = {}) => {
  // window.heap.addUserProperties(properties)
};

/**
 * Util function that adds a key onto the event object in heap
 * see https://developers.heap.io/reference#addeventproperties
 * @param {object} properties Dictionary that adds keys onto the user object in heap. Values must be a string or integer.
 */
export const addEventProperty = (properties = {}) => {
  // window.heap.addEventProperties(properties)
};
/**
 * Used to turn on hotjar in certain situations. Also sets local storage to see if we can call identify.
 */
export const initializeHotjar = () => {
  const shouldHotjarLoad = localStorage.getItem('shouldHotjarLoad');
  if (process.env.REACT_APP_NODE_ENV === 'production' && shouldHotjarLoad === 'true') {
    hotjar.initialize(1956626, 6);
  }
};

/**
 * Checks to see if hotjar has been initialized, if so we call identify so we can track the user in the Hotjar recording
 * @param {string} email primary user identifier.
 */
export const identifyHotjarUser = ({ email }) => {
  if (process.env.REACT_APP_NODE_ENV === 'production' && window.hj) {
    hotjar.identify(email, { email });
  }
};